module.exports = "<template> <div class=\"tyl-badge tyl-badge--open\"> <slot></slot> </div> </template>";